export const top250FontsMap = {
  abeezee: {
    fontFamily: "ABeeZee",
  },
  abel: {
    fontFamily: "Abel",
  },
  "abril fatface": {
    fontFamily: "Abril Fatface",
  },
  acme: {
    fontFamily: "Acme",
  },
  "advent pro": {
    fontFamily: "Advent Pro",
  },
  alata: {
    fontFamily: "Alata",
  },
  alegreya: {
    fontFamily: "Alegreya",
  },
  "alegreya sans": {
    fontFamily: "Alegreya Sans",
  },
  "alegreya sans sc": {
    fontFamily: "Alegreya Sans SC",
  },
  aleo: {
    fontFamily: "Aleo",
  },
  "alfa slab one": {
    fontFamily: "Alfa Slab One",
  },
  alice: {
    fontFamily: "Alice",
  },
  almarai: {
    fontFamily: "Almarai",
  },
  "amatic sc": {
    fontFamily: "Amatic SC",
  },
  amiri: {
    fontFamily: "Amiri",
  },
  "antic slab": {
    fontFamily: "Antic Slab",
  },
  anton: {
    fontFamily: "Anton",
  },
  antonio: {
    fontFamily: "Antonio",
  },
  "architects daughter": {
    fontFamily: "Architects Daughter",
  },
  archivo: {
    fontFamily: "Archivo",
  },
  "archivo black": {
    fontFamily: "Archivo Black",
  },
  "archivo narrow": {
    fontFamily: "Archivo Narrow",
  },
  arimo: {
    fontFamily: "Arimo",
  },
  arsenal: {
    fontFamily: "Arsenal",
  },
  arvo: {
    fontFamily: "Arvo",
  },
  asap: {
    fontFamily: "Asap",
  },
  "asap condensed": {
    fontFamily: "Asap Condensed",
  },
  assistant: {
    fontFamily: "Assistant",
  },
  "baloo 2": {
    fontFamily: "Baloo 2",
  },
  bangers: {
    fontFamily: "Bangers",
  },
  barlow: {
    fontFamily: "Barlow",
  },
  "barlow condensed": {
    fontFamily: "Barlow Condensed",
  },
  "barlow semi condensed": {
    fontFamily: "Barlow Semi Condensed",
  },
  "be vietnam pro": {
    fontFamily: "Be Vietnam Pro",
  },
  "bebas neue": {
    fontFamily: "Bebas Neue",
  },
  bitter: {
    fontFamily: "Bitter",
  },
  "bodoni moda": {
    fontFamily: "Bodoni Moda",
  },
  "bree serif": {
    fontFamily: "Bree Serif",
  },
  cabin: {
    fontFamily: "Cabin",
  },
  cairo: {
    fontFamily: "Cairo",
  },
  cantarell: {
    fontFamily: "Cantarell",
  },
  cardo: {
    fontFamily: "Cardo",
  },
  "carter one": {
    fontFamily: "Carter One",
  },
  catamaran: {
    fontFamily: "Catamaran",
  },
  caveat: {
    fontFamily: "Caveat",
  },
  "chakra petch": {
    fontFamily: "Chakra Petch",
  },
  changa: {
    fontFamily: "Changa",
  },
  chivo: {
    fontFamily: "Chivo",
  },
  cinzel: {
    fontFamily: "Cinzel",
  },
  comfortaa: {
    fontFamily: "Comfortaa",
  },
  commissioner: {
    fontFamily: "Commissioner",
  },
  "concert one": {
    fontFamily: "Concert One",
  },
  cookie: {
    fontFamily: "Cookie",
  },
  cormorant: {
    fontFamily: "Cormorant",
  },
  "cormorant garamond": {
    fontFamily: "Cormorant Garamond",
  },
  courgette: {
    fontFamily: "Courgette",
  },
  "crete round": {
    fontFamily: "Crete Round",
  },
  "crimson pro": {
    fontFamily: "Crimson Pro",
  },
  "crimson text": {
    fontFamily: "Crimson Text",
  },
  cuprum: {
    fontFamily: "Cuprum",
  },
  "dm sans": {
    fontFamily: "DM Sans",
  },
  "dm serif display": {
    fontFamily: "DM Serif Display",
  },
  "dm serif text": {
    fontFamily: "DM Serif Text",
  },
  "dancing script": {
    fontFamily: "Dancing Script",
  },
  "didact gothic": {
    fontFamily: "Didact Gothic",
  },
  domine: {
    fontFamily: "Domine",
  },
  dosis: {
    fontFamily: "Dosis",
  },
  "eb garamond": {
    fontFamily: "EB Garamond",
  },
  "el messiri": {
    fontFamily: "El Messiri",
  },
  "encode sans": {
    fontFamily: "Encode Sans",
  },
  exo: {
    fontFamily: "Exo",
  },
  "exo 2": {
    fontFamily: "Exo 2",
  },
  faustina: {
    fontFamily: "Faustina",
  },
  figtree: {
    fontFamily: "Figtree",
  },
  "fira sans": {
    fontFamily: "Fira Sans",
  },
  "fira sans condensed": {
    fontFamily: "Fira Sans Condensed",
  },
  "fira sans extra condensed": {
    fontFamily: "Fira Sans Extra Condensed",
  },
  "fjalla one": {
    fontFamily: "Fjalla One",
  },
  "francois one": {
    fontFamily: "Francois One",
  },
  "frank ruhl libre": {
    fontFamily: "Frank Ruhl Libre",
  },
  gelasio: {
    fontFamily: "Gelasio",
  },
  "gloria hallelujah": {
    fontFamily: "Gloria Hallelujah",
  },
  "gothic a1": {
    fontFamily: "Gothic A1",
  },
  "great vibes": {
    fontFamily: "Great Vibes",
  },
  gruppo: {
    fontFamily: "Gruppo",
  },
  handlee: {
    fontFamily: "Handlee",
  },
  heebo: {
    fontFamily: "Heebo",
  },
  hind: {
    fontFamily: "Hind",
  },
  "hind madurai": {
    fontFamily: "Hind Madurai",
  },
  "hind siliguri": {
    fontFamily: "Hind Siliguri",
  },
  "ibm plex mono": {
    fontFamily: "IBM Plex Mono",
  },
  "ibm plex sans": {
    fontFamily: "IBM Plex Sans",
  },
  "ibm plex sans arabic": {
    fontFamily: "IBM Plex Sans Arabic",
  },
  "ibm plex sans condensed": {
    fontFamily: "IBM Plex Sans Condensed",
  },
  "ibm plex serif": {
    fontFamily: "IBM Plex Serif",
  },
  inconsolata: {
    fontFamily: "Inconsolata",
  },
  "indie flower": {
    fontFamily: "Indie Flower",
  },
  inter: {
    fontFamily: "Inter",
  },
  "josefin sans": {
    fontFamily: "Josefin Sans",
  },
  "josefin slab": {
    fontFamily: "Josefin Slab",
  },
  jost: {
    fontFamily: "Jost",
  },
  kalam: {
    fontFamily: "Kalam",
  },
  kanit: {
    fontFamily: "Kanit",
  },
  karla: {
    fontFamily: "Karla",
  },
  "kaushan script": {
    fontFamily: "Kaushan Script",
  },
  khand: {
    fontFamily: "Khand",
  },
  "kosugi maru": {
    fontFamily: "Kosugi Maru",
  },
  lato: {
    fontFamily: "Lato",
  },
  lexend: {
    fontFamily: "Lexend",
  },
  "lexend deca": {
    fontFamily: "Lexend Deca",
  },
  "libre baskerville": {
    fontFamily: "Libre Baskerville",
  },
  "libre franklin": {
    fontFamily: "Libre Franklin",
  },
  "lilita one": {
    fontFamily: "Lilita One",
  },
  lobster: {
    fontFamily: "Lobster",
  },
  "lobster two": {
    fontFamily: "Lobster Two",
  },
  lora: {
    fontFamily: "Lora",
  },
  "luckiest guy": {
    fontFamily: "Luckiest Guy",
  },
  "m plus 1p": {
    fontFamily: "M PLUS 1p",
  },
  "m plus rounded 1c": {
    fontFamily: "M PLUS Rounded 1c",
  },
  manrope: {
    fontFamily: "Manrope",
  },
  marcellus: {
    fontFamily: "Marcellus",
  },
  "marck script": {
    fontFamily: "Marck Script",
  },
  martel: {
    fontFamily: "Martel",
  },
  mate: {
    fontFamily: "Mate",
  },
  "mate sc": {
    fontFamily: "Mate SC",
  },
  "maven pro": {
    fontFamily: "Maven Pro",
  },
  merriweather: {
    fontFamily: "Merriweather",
  },
  "merriweather sans": {
    fontFamily: "Merriweather Sans",
  },
  mitr: {
    fontFamily: "Mitr",
  },
  montserrat: {
    fontFamily: "Montserrat",
  },
  "montserrat alternates": {
    fontFamily: "Montserrat Alternates",
  },
  "mr dafoe": {
    fontFamily: "Mr Dafoe",
  },
  mukta: {
    fontFamily: "Mukta",
  },
  "mukta malar": {
    fontFamily: "Mukta Malar",
  },
  mulish: {
    fontFamily: "Mulish",
  },
  "nanum gothic": {
    fontFamily: "Nanum Gothic",
  },
  "nanum myeongjo": {
    fontFamily: "Nanum Myeongjo",
  },
  neucha: {
    fontFamily: "Neucha",
  },
  neuton: {
    fontFamily: "Neuton",
  },
  "news cycle": {
    fontFamily: "News Cycle",
  },
  "noticia text": {
    fontFamily: "Noticia Text",
  },
  "noto color emoji": {
    fontFamily: "Noto Color Emoji",
  },
  "noto kufi arabic": {
    fontFamily: "Noto Kufi Arabic",
  },
  "noto sans": {
    fontFamily: "Noto Sans",
  },
  "noto sans arabic": {
    fontFamily: "Noto Sans Arabic",
  },
  "noto sans display": {
    fontFamily: "Noto Sans Display",
  },
  "noto sans hk": {
    fontFamily: "Noto Sans HK",
  },
  "noto sans jp": {
    fontFamily: "Noto Sans JP",
  },
  "noto sans kr": {
    fontFamily: "Noto Sans KR",
  },
  "noto sans sc": {
    fontFamily: "Noto Sans SC",
  },
  "noto sans tc": {
    fontFamily: "Noto Sans TC",
  },
  "noto sans thai": {
    fontFamily: "Noto Sans Thai",
  },
  "noto serif": {
    fontFamily: "Noto Serif",
  },
  "noto serif jp": {
    fontFamily: "Noto Serif JP",
  },
  "noto serif kr": {
    fontFamily: "Noto Serif KR",
  },
  "noto serif tc": {
    fontFamily: "Noto Serif TC",
  },
  nunito: {
    fontFamily: "Nunito",
  },
  "nunito sans": {
    fontFamily: "Nunito Sans",
  },
  "old standard tt": {
    fontFamily: "Old Standard TT",
  },
  "open sans": {
    fontFamily: "Open Sans",
  },
  orbitron: {
    fontFamily: "Orbitron",
  },
  oswald: {
    fontFamily: "Oswald",
  },
  outfit: {
    fontFamily: "Outfit",
  },
  overpass: {
    fontFamily: "Overpass",
  },
  oxygen: {
    fontFamily: "Oxygen",
  },
  "pt sans": {
    fontFamily: "PT Sans",
  },
  "pt sans caption": {
    fontFamily: "PT Sans Caption",
  },
  "pt sans narrow": {
    fontFamily: "PT Sans Narrow",
  },
  "pt serif": {
    fontFamily: "PT Serif",
  },
  pacifico: {
    fontFamily: "Pacifico",
  },
  "passion one": {
    fontFamily: "Passion One",
  },
  "pathway gothic one": {
    fontFamily: "Pathway Gothic One",
  },
  "patrick hand": {
    fontFamily: "Patrick Hand",
  },
  "patua one": {
    fontFamily: "Patua One",
  },
  "paytone one": {
    fontFamily: "Paytone One",
  },
  "permanent marker": {
    fontFamily: "Permanent Marker",
  },
  philosopher: {
    fontFamily: "Philosopher",
  },
  play: {
    fontFamily: "Play",
  },
  "playfair display": {
    fontFamily: "Playfair Display",
  },
  "playfair display sc": {
    fontFamily: "Playfair Display SC",
  },
  "plus jakarta sans": {
    fontFamily: "Plus Jakarta Sans",
  },
  "poiret one": {
    fontFamily: "Poiret One",
  },
  poppins: {
    fontFamily: "Poppins",
  },
  prata: {
    fontFamily: "Prata",
  },
  "press start 2p": {
    fontFamily: "Press Start 2P",
  },
  prompt: {
    fontFamily: "Prompt",
  },
  "public sans": {
    fontFamily: "Public Sans",
  },
  quattrocento: {
    fontFamily: "Quattrocento",
  },
  "quattrocento sans": {
    fontFamily: "Quattrocento Sans",
  },
  questrial: {
    fontFamily: "Questrial",
  },
  quicksand: {
    fontFamily: "Quicksand",
  },
  rajdhani: {
    fontFamily: "Rajdhani",
  },
  raleway: {
    fontFamily: "Raleway",
  },
  "red hat display": {
    fontFamily: "Red Hat Display",
  },
  righteous: {
    fontFamily: "Righteous",
  },
  roboto: {
    fontFamily: "Roboto",
  },
  "roboto condensed": {
    fontFamily: "Roboto Condensed",
  },
  "roboto flex": {
    fontFamily: "Roboto Flex",
  },
  "roboto mono": {
    fontFamily: "Roboto Mono",
  },
  "roboto serif": {
    fontFamily: "Roboto Serif",
  },
  "roboto slab": {
    fontFamily: "Roboto Slab",
  },
  rokkitt: {
    fontFamily: "Rokkitt",
  },
  rowdies: {
    fontFamily: "Rowdies",
  },
  rubik: {
    fontFamily: "Rubik",
  },
  "russo one": {
    fontFamily: "Russo One",
  },
  sacramento: {
    fontFamily: "Sacramento",
  },
  saira: {
    fontFamily: "Saira",
  },
  "saira condensed": {
    fontFamily: "Saira Condensed",
  },
  sanchez: {
    fontFamily: "Sanchez",
  },
  sarabun: {
    fontFamily: "Sarabun",
  },
  satisfy: {
    fontFamily: "Satisfy",
  },
  "sawarabi gothic": {
    fontFamily: "Sawarabi Gothic",
  },
  "sawarabi mincho": {
    fontFamily: "Sawarabi Mincho",
  },
  "secular one": {
    fontFamily: "Secular One",
  },
  sen: {
    fontFamily: "Sen",
  },
  "shadows into light": {
    fontFamily: "Shadows Into Light",
  },
  signika: {
    fontFamily: "Signika",
  },
  "signika negative": {
    fontFamily: "Signika Negative",
  },
  "slabo 27px": {
    fontFamily: "Slabo 27px",
  },
  sora: {
    fontFamily: "Sora",
  },
  "source code pro": {
    fontFamily: "Source Code Pro",
  },
  "source serif 4": {
    fontFamily: "Source Serif 4",
  },
  "space grotesk": {
    fontFamily: "Space Grotesk",
  },
  "space mono": {
    fontFamily: "Space Mono",
  },
  "special elite": {
    fontFamily: "Special Elite",
  },
  spectral: {
    fontFamily: "Spectral",
  },
  staatliches: {
    fontFamily: "Staatliches",
  },
  tajawal: {
    fontFamily: "Tajawal",
  },
  teko: {
    fontFamily: "Teko",
  },
  "tenor sans": {
    fontFamily: "Tenor Sans",
  },
  tinos: {
    fontFamily: "Tinos",
  },
  "titillium web": {
    fontFamily: "Titillium Web",
  },
  ubuntu: {
    fontFamily: "Ubuntu",
  },
  "ubuntu condensed": {
    fontFamily: "Ubuntu Condensed",
  },
  "ubuntu mono": {
    fontFamily: "Ubuntu Mono",
  },
  ultra: {
    fontFamily: "Ultra",
  },
  unbounded: {
    fontFamily: "Unbounded",
  },
  unna: {
    fontFamily: "Unna",
  },
  urbanist: {
    fontFamily: "Urbanist",
  },
  "varela round": {
    fontFamily: "Varela Round",
  },
  vidaloka: {
    fontFamily: "Vidaloka",
  },
  viga: {
    fontFamily: "Viga",
  },
  vollkorn: {
    fontFamily: "Vollkorn",
  },
  "work sans": {
    fontFamily: "Work Sans",
  },
  "yanone kaffeesatz": {
    fontFamily: "Yanone Kaffeesatz",
  },
  yantramanav: {
    fontFamily: "Yantramanav",
  },
  yellowtail: {
    fontFamily: "Yellowtail",
  },
  "yeseva one": {
    fontFamily: "Yeseva One",
  },
  zeyada: {
    fontFamily: "Zeyada",
  },
  "zilla slab": {
    fontFamily: "Zilla Slab",
  },
};
